import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("spread_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Request failed.";
}

// Build an authenticated media URL for <audio>/<img> tags (token via query param)
export function mediaUrl(path) {
  if (!path) return null;
  const token = localStorage.getItem("spread_token");
  return `${API}/files/${path}?auth=${token}`;
}

export function srcForAudio(ep) {
  if (!ep) return null;
  if (ep.audio_url) return ep.audio_url;
  if (ep.audio_path) return mediaUrl(ep.audio_path);
  return null;
}

export function srcForCover(ep) {
  if (!ep) return null;
  if (ep.cover_image_url) return ep.cover_image_url;
  if (ep.cover_image_path) return mediaUrl(ep.cover_image_path);
  return "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxwb2RjYXN0JTIwbWljcm9waG9uZSUyMHN0dWRpbyUyMHdhcm18ZW58MHx8fHwxNzg2OTAzNDczfDA&ixlib=rb-4.1.0&q=85";
}
